"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  COLOR_NOT_SET: 'color',
  COLOR_TOO_LONG: 'color',
  COLOR_INVALID: 'color',
  COMPLETED_MESSAGE_HTML_TOO_LONG: 'completedMessageHtml',
  CTA_CONTAINS_NEW_LINES: 'cta',
  CTA_NOT_SET: 'cta',
  CTA_TOO_LONG: 'cta',
  DELAY_TOO_SHORT: 'triggers',
  DESCRIPTION_TOO_LONG: 'description',
  EMAIL_MESSAGE_NOT_SET: 'emailMessageHtml',
  EMAIL_NOT_INCLUDED: 'formFields',
  FORM_DESCRIPTION_TOO_LONG: 'formDescription',
  FORM_FIELDS_CONTAINS_NON_BASIC: 'formFields',
  FORM_FIELDS_SIZE_TOO_LARGE: 'formFields',
  FORM_FIELDS_SIZE_TOO_SMALL: 'formFields',
  HEADING_CONTAINS_NEW_LINES: 'heading',
  HEADING_NOT_SET: 'heading',
  HEADING_TOO_LONG: 'heading',
  IMAGE_ORIGINAL_URL_INVALID: 'image',
  IMAGE_RESIZED_URL_INVALID: 'image',
  NAME_CONTAINS_NEW_LINES: 'name',
  NAME_NOT_SET: 'name',
  NAME_NOT_UNIQUE: 'name',
  NAME_TOO_LONG: 'name',
  NO_TRIGGER: 'triggers',
  REDIRECT_URL_INVALID: 'redirectUrl',
  REDIRECT_URL_NOT_PRESENT: 'redirectUrl',
  SENDER_ID_NOT_PRESENT: 'emailSenderUserId',
  SUBJECT_LINE_NOT_SET: 'emailSubjectLine',
  URL_WHITELIST_TOO_LONG: 'urlWhitelist',
  USER_NOT_PERMITTED: 'emailSenderUserId',
  USER_NOT_PRESENT: 'emailSenderUserId',
  USER_NOT_VERIFIED: 'emailSenderUserId',
  PORTAL_SUSPENDED: 'kickback'
};
exports.default = _default;
module.exports = exports.default;